<a [routerLink]="this.hyperLink">
  <div class="overflow-hidden h-full border hover:shadow-lg text-sm text-gray-800">

    @if (!imageLoadFailed) {
      <img class="object-cover object-center w-full h-52" [src]="displayEventImage()" alt="avatar"
           (error)="onImageError()">
    } @else {
      <div class="flex h-52 w-full flex-col items-center justify-center bg-slate-100 text-slate-500">
        <i class="pi pi-image text-4xl opacity-70"></i>
        <span class="mt-2 text-xs">Sem imagem</span>
      </div>
    }

    <!-- info -->
    <div class="px-6 py-4 text-left flex flex-col" style="height: 225px">

        <h1 class="flex-none text-base font-semibold">{{event.title}}</h1>

        <div class="grow">
          <p class="py-2 text-gray-500 h-full multi-line-truncate">{{event.description | textTruncate:200}}</p>
        </div>

        <div class="flex-none">
          <span [ngClass]="event.intent?.code === 'FOUND'
            ? 'mb-3 inline-block bg-emerald-600 px-2 py-1 text-xs font-semibold text-white'
            : 'mb-3 inline-block bg-[#ff7900] px-2 py-1 text-xs font-semibold text-white'">
            {{ event.intent?.description ?? 'À procura' }}
          </span>
          <hr>
          <!-- location and date -->
          <div class="flex items-center mt-4 lowercase">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none"
                 viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round"
                    d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/>
              <path stroke-linecap="round" stroke-linejoin="round"
                    d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"/>
            </svg>
            <h1 class="px-2 text-sm">{{event.province.description | titlecase}}
              , {{event.eventDate | date:'dd-MM-yyyy'}}</h1>
          </div>
        </div>

    </div>
  </div>
</a>
